import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Años de terapia sin resolver la raíz',
    cost: 'Tiempo, dinero y desgaste sin resultados duraderos'
  }, {
    without: 'Meditar sin limpiar el campo real',
    cost: 'Alivio temporal que no transforma'
  }, {
    without: 'Vínculos que siguen drenando sin herramienta',
    cost: 'Energía propia entregada sin retorno'
  }, {
    without: 'Decisiones desde el miedo y la culpa',
    cost: 'Vida construida desde una base falsa'
  }, {
    without: 'Insomnio y cansancio crónico sin protocolo',
    cost: 'Cuerpo pagando el costo emocional'
  }, {
    without: 'El mismo patrón volviendo una y otra vez',
    cost: 'Otro año igual al que acabás de tener'
  }];
  return <Section data-id="element-38">
      <div className="text-center mb-12" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 flex items-center justify-center" data-id="element-40">
          <span className="mr-3" data-id="element-41">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto overflow-x-auto pb-6 scrollbar-hide" data-id="element-42">
        <div className="min-w-[600px]" data-id="element-43">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-44">
            <div className="font-serif font-bold text-lg text-brand-text/80" data-id="element-45">
              Sin el Método
            </div>
            <div className="font-serif font-bold text-lg text-red-400" data-id="element-46">
              Costo real
            </div>
          </div>

          <div className="space-y-3" data-id="element-47">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-red-500/10" data-id="element-48">
                <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-49">
                  {row.without}
                </div>
                <div className="text-sm text-red-300/90" data-id="element-50">{row.cost}</div>
              </div>)}
          </div>
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-51">
        <h3 className="text-2xl md:text-3xl font-serif font-bold gold-gradient-text mb-6" data-id="element-52">
          El próximo año puede ser completamente diferente.
        </h3>
        <p className="text-xl italic text-brand-text/80" data-id="element-53">
          "El campo limpio no es el destino. Es el punto de partida." 🌟
        </p>
      </div>
    </Section>;
};